import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage, tr } from "../i18n";
import { lp } from "../components/Navbar";
import { PageHero } from "./Shared";
import { Reveal } from "../components/motion";
import { articles } from "../data/articles";
const CATEGORIES = ["All", "AI Governance", "AI Ethics", "AI Risk", "AI Agents", "EU AI Act", "AI Assurance", "Corporate AI", "Standards", "Certification"];
export default function Insights() {
  const {
    lang
  } = useLanguage();
  const [cat, setCat] = useState("All");
  const filtered = cat === "All" ? articles : articles.filter(a => a.category === cat);
  return <div data-testid="insights-page">
      <PageHero kicker={tr("ESAIA Insights")} title={tr("Evidence-based perspectives on responsible AI.")} copy={tr("Analysis from the ESAIA Standards Secretariat on AI governance, risk, agents, assurance and certification, written for leaders who carry responsibility for AI in their organization.")} />

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="flex flex-wrap gap-2" role="tablist" aria-label={tr("Article categories")} data-testid="insights-filters">
          {CATEGORIES.map(c => <button key={c} onClick={() => setCat(c)} data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`} className={`border px-4 py-2 font-mono text-[11px] uppercase tracking-[0.15em] transition-colors ${cat === c ? "border-esaia-blue bg-esaia-blue text-white" : "border-esaia-line bg-white text-esaia-muted hover:border-esaia-blue/50 hover:text-esaia-ink"}`}>
              {tr(c)}
            </button>)}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-7 md:grid-cols-2 lg:grid-cols-3">
          {filtered.map((a, i) => <Reveal key={a.slug} delay={Math.min(i * 0.08, 0.3)} y={18} once={false} className="h-full">
              <Link to={lp(lang, `/insights/${a.slug}`)} data-testid={`article-card-${a.slug}`} className="group flex h-full flex-col border border-esaia-line bg-white p-7 transition-all duration-300 hover:border-esaia-blue/50 hover:shadow-md">
                <div className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.2em] text-esaia-subtle">
                  <span className="text-esaia-blue">{tr(a.category)}</span>
                  <span>{a.date}</span>
                  <span>{tr(a.readTime)}</span>
                </div>
                <h2 className="mt-4 text-lg font-semibold leading-snug text-esaia-ink transition-colors group-hover:text-esaia-blue">
                  {tr(a.title)}
                </h2>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-esaia-muted">{tr(a.excerpt)}</p>
                <span className="mt-6 inline-flex items-center gap-2 text-xs font-semibold text-esaia-blue">{tr("Read article")}{" "}<ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>)}
        </div>
        {filtered.length === 0 && <p className="mt-10 text-sm text-esaia-subtle" data-testid="insights-empty">{tr("No articles in this category yet.")}{" "}</p>}
      </section>
    </div>;
}
